var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn no-bg",
                  on: {
                    click: function($event) {
                      return _vm.onClickBack()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n      " + _vm._s(_vm.product.product_name) + "\n    ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn no-bg",
                  on: {
                    click: function($event) {
                      return _vm.onClickDone()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-check" })]
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "container-form" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-12 mt-4 mb-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.chooseone")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "ul",
                        {
                          class: [
                            "wrapper-items",
                            { "is-invalid": _vm.isInvalid }
                          ]
                        },
                        _vm._l(_vm.product.prices, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: [
                                "row no-margin item fixed-layout",
                                {
                                  disabled:
                                    _vm.isNotAvailable(item) ||
                                    _vm.isOutOfStock(item)
                                }
                              ]
                            },
                            [
                              _c("vs-radio", {
                                staticClass: "container-vs-radio",
                                attrs: {
                                  disabled:
                                    _vm.isNotAvailable(item) ||
                                    _vm.isOutOfStock(item),
                                  vsValue: item.sku_id,
                                  color: "#A3CA76"
                                },
                                on: { change: _vm.handleSkuIdChange },
                                model: {
                                  value: _vm.radioSkuId,
                                  callback: function($$v) {
                                    _vm.radioSkuId = $$v
                                  },
                                  expression: "radioSkuId"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _c(
                                  "p",
                                  { staticClass: "limit-line" },
                                  [
                                    _vm._l(item.attributes, function(
                                      attr,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm.stockCount(_vm.product, item.sku_id)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-secondary",
                                                staticStyle: {
                                                  "font-size": "12px",
                                                  position: "relative",
                                                  top: "0px"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-box-open",
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    position: "relative",
                                                    top: "1px"
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.stockCount(
                                                        _vm.product,
                                                        item.sku_id
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "_name",
                                            staticStyle: { "font-size": "9px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(attr.name) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "_name" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(attr.option) +
                                                "\n                        "
                                            ),
                                            index < item.attributes.length - 1
                                              ? [_vm._v(", ")]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ])
                                    }),
                                    _vm._v(" "),
                                    _vm.isNotAvailable(item)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-danger",
                                            staticStyle: {
                                              "font-size": "9px",
                                              position: "relative",
                                              top: "-1px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.productisnotavailable"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isOutOfStock(item)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-danger",
                                            staticStyle: {
                                              "font-size": "9px",
                                              position: "relative",
                                              top: "-1px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t("message.outofstock")
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-right price" },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.getNumber(item.price) ||
                                              _vm.$t("message.variable")
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isCustomPrice(item.sku_id)
                                    ? _c(
                                        "vs-tooltip",
                                        {
                                          staticStyle: {
                                            float: "right",
                                            "margin-right": "6px",
                                            cursor: "pointer"
                                          },
                                          attrs: {
                                            text: _vm
                                              .$t("message.customprice")
                                              .toLowerCase(),
                                            position: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-secondary",
                                              staticStyle: {
                                                height: "15px",
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "font-size": "9px",
                                                position: "relative",
                                                top: "4px"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-calculator",
                                                staticStyle: {
                                                  "font-size": "10px",
                                                  top: "0px"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isProductUseLot(item)
                                    ? _c(
                                        "vs-tooltip",
                                        {
                                          staticStyle: {
                                            float: "right",
                                            "margin-right": "6px",
                                            cursor: "pointer"
                                          },
                                          attrs: {
                                            text: _vm
                                              .$t("message.chooselot")
                                              .toLowerCase(),
                                            position: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-secondary",
                                              staticStyle: {
                                                height: "15px",
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "font-size": "9px",
                                                position: "relative",
                                                top: "4px"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-pallet",
                                                staticStyle: {
                                                  "font-size": "10px",
                                                  top: "0px"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isProductUseSerial(item)
                                    ? _c(
                                        "vs-tooltip",
                                        {
                                          staticStyle: {
                                            float: "right",
                                            "margin-right": "6px",
                                            cursor: "pointer"
                                          },
                                          attrs: {
                                            text: _vm
                                              .$t("message.chooselot")
                                              .toLowerCase(),
                                            position: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-secondary",
                                              staticStyle: {
                                                height: "15px",
                                                display: "flex",
                                                "align-items": "center",
                                                "justify-content": "center",
                                                "font-size": "9px",
                                                position: "relative",
                                                top: "4px"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-sd-card",
                                                staticStyle: {
                                                  "font-size": "10px",
                                                  top: "0px"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              (_vm.isSelectedLot &&
                                _vm.radioSkuId === item.sku_id) ||
                              (_vm.isProductUseLot(item) &&
                                _vm.product.prices.length === 1)
                                ? _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row m-0" },
                                      _vm._l(_vm.lot.selected, function(
                                        lotItem,
                                        lotIndex
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: lotIndex,
                                            staticClass:
                                              "col-12 no-padding mt-1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "outer-modifier row",
                                                staticStyle: {
                                                  color: "#BBBBBB",
                                                  "font-size": "14px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-8 name" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            lotItem.lotCode
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-pallet",
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                          position: "relative",
                                                          top: "-1px"
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-4 price text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(lotItem.unit) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row mt-1" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c(
                                            "BaseButton",
                                            {
                                              attrs: { className: "btn-sm" },
                                              on: {
                                                click: _vm.onClickOpenLotModal
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.inventory.button.selectlotnumber"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.isSelectedSerial &&
                                _vm.radioSkuId === item.sku_id) ||
                              (_vm.isProductUseSerial(item) &&
                                _vm.product.prices.length === 1)
                                ? _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row m-0" },
                                      _vm._l(_vm.serial.selected, function(
                                        serialItem,
                                        serialIndex
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: serialIndex,
                                            staticClass:
                                              "col-12 no-padding mt-1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "outer-modifier row",
                                                staticStyle: {
                                                  color: "#BBBBBB",
                                                  "font-size": "14px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-8 name" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            serialItem.serCode
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-sd-card",
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                          position: "relative",
                                                          top: "-1px"
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-4 price text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          serialItem.unit
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-12",
                                                    staticStyle: {
                                                      "font-size": "11px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          serialItem.serialNumber
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row mt-1" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c(
                                            "BaseButton",
                                            {
                                              attrs: { className: "btn-sm" },
                                              on: {
                                                click:
                                                  _vm.onClickOpenSerialModal
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.inventory.button.selectserialnumber"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.product.modifiers, function(item, index) {
                      return _c("div", { key: index, staticClass: "col-12" }, [
                        _c("div", { staticClass: "col no-padding mt-4 mb-1" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.modifier_name) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "wrapper-items" },
                          _vm._l(item.options, function(item_, index_) {
                            return _c(
                              "li",
                              {
                                key: index_,
                                staticClass: "row no-margin item fixed-layout"
                              },
                              [
                                _c("vs-checkbox", {
                                  staticClass: "container-vs-checkbox",
                                  attrs: {
                                    vsValue: item_.modifieroption_id,
                                    color: "#A3CA76"
                                  },
                                  model: {
                                    value: _vm.checkBoxModifierOptionIds,
                                    callback: function($$v) {
                                      _vm.checkBoxModifierOptionIds = $$v
                                    },
                                    expression: "checkBoxModifierOptionIds"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "name" }, [
                                  _c("p", { staticClass: "limit-line" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item_.option) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-right price" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.getNumber(item_.price)) +
                                      "\n                "
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row" }, [
                  _vm.discounts.length > 0
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col no-padding mt-4 mb-1 text-uppercase"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.discounts")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "wrapper-items col-12" },
                          _vm._l(_vm.discounts, function(item, index) {
                            return _c(
                              "li",
                              { key: index, class: ["row", "item", item.type] },
                              [
                                _c("div", { staticClass: "col-8 name" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.discount_name) +
                                      "\n                  "
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.amountText) +
                                        "\n                  "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-4 text-right price" },
                                  [
                                    !_vm.useBarcodeScanner
                                      ? _c("vs-switch", {
                                          staticStyle: {
                                            float: "right",
                                            margin: "0 0 0 10px"
                                          },
                                          attrs: {
                                            disabled:
                                              item.type === "conditional",
                                            color: "#A3CA76",
                                            vsType: "success"
                                          },
                                          model: {
                                            value: _vm.switchDiscountIds[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.switchDiscountIds,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "switchDiscountIds[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.type === "conditional"
                                      ? _c(
                                          "Tooltip",
                                          {
                                            staticStyle: { float: "right" },
                                            attrs: { position: "bottom" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "message",
                                                  fn: function() {
                                                    return _vm._l(
                                                      item.tooltipTexts,
                                                      function(
                                                        text,
                                                        textIndex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: textIndex,
                                                            staticClass:
                                                              "alert alert-secondary text-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(text) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-secondary",
                                                staticStyle: {
                                                  position: "relative",
                                                  top: "2px",
                                                  "max-width": "80px",
                                                  overflow: "hidden"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.conditional"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.taxes.length > 0
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col no-padding mt-4 mb-1 text-uppercase"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.taxes")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "wrapper-items col-12" },
                          _vm._l(_vm.taxes, function(item, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "row item" },
                              [
                                _c("div", { staticClass: "col-8 name" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.tax_name) +
                                      " " +
                                      _vm._s(item.amount) +
                                      "%\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-4 text-right price" },
                                  [
                                    !_vm.useBarcodeScanner
                                      ? _c("vs-switch", {
                                          staticStyle: {
                                            float: "right",
                                            margin: "0"
                                          },
                                          attrs: {
                                            vsType: "success",
                                            color: "#A3CA76"
                                          },
                                          model: {
                                            value: _vm.switchTaxIds[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.switchTaxIds,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "switchTaxIds[index]"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col no-padding mt-4 mb-1 text-uppercase"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.noteandquantity")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "wrapper-items" }, [
                      _c(
                        "li",
                        {
                          staticClass: "row no-margin item",
                          staticStyle: {
                            background: "none",
                            border: "none",
                            cursor: "default",
                            "padding-bottom": "0"
                          }
                        },
                        [
                          _c("div", { staticClass: "col-7 name no-padding" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.note,
                                  expression: "note"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: {
                                height: "40px",
                                border: "solid 1px #D8E2E7",
                                "border-right": "none",
                                "border-radius": "0"
                              },
                              attrs: {
                                placeholder: _vm.$t("placeholder.addnote")
                              },
                              domProps: { value: _vm.note },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.note = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-5 text-right price",
                              staticStyle: { "padding-right": "0" }
                            },
                            [
                              _c("BaseVsInputNumber", {
                                ref: "quantity",
                                staticClass: "custom-vs-input-number",
                                attrs: {
                                  disabled:
                                    !!_vm.isSelectedLot ||
                                    !!_vm.isSelectedSerial,
                                  color: "#A3CA76",
                                  min: "1"
                                },
                                on: { click: _vm.selectedInputQuantity },
                                model: {
                                  value: _vm.quantity,
                                  callback: function($$v) {
                                    _vm.quantity = $$v
                                  },
                                  expression: "quantity"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("BaseSelectLotNumberModal", {
              attrs: {
                show: _vm.lotModal.show,
                loading: _vm.lotModal.loading,
                lots: _vm.lotList,
                selected: _vm.lot.selected,
                index: 0,
                skuId: _vm.lot.skuId
              },
              on: {
                onClose: _vm.handleCloseLotModal,
                onCancel: _vm.handleCancleLotModal,
                onSubmit: _vm.handleSumitLotModal,
                onSortChange: _vm.handleSortLotChange
              }
            }),
            _vm._v(" "),
            _c("BaseSelectSerialNumberModal", {
              attrs: {
                show: _vm.serialModal.show,
                loading: _vm.serialModal.loading,
                serials: _vm.serialList,
                selected: _vm.serial.selected,
                index: 0,
                skuId: _vm.serial.skuId
              },
              on: {
                onClose: _vm.handleCloseSerialModal,
                onCancel: _vm.handleCancleSerialModal,
                onSubmit: _vm.handleSumitSerialModal,
                onSortChange: _vm.handleSortSerialChange
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-097af9d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-097af9d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/ChooseAttribute.vue
// module id = null
// module chunks = 